import React from "react";

export default function ArrowRight() {
  return (
    <svg
      width="32"
      height="14"
      viewBox="0 0 32 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M30 6.99975L0 6.99976" stroke="white" strokeWidth="1.5" />
      <path
        d="M23.3994 0.999756L29.9994 6.86637L23.3994 13.1996"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  );
}
